export const STANDALONE_PERMISSION_OVERRIDE_STORAGE_PREFIX = '__STANDALONE_PERMISSION_OVERRIDES_V1__';

// These permissions are used in the context of virtual-devices
export const PROVISIONING_PERMISSIONS = [
  'prov.logDevRead',
  'prov.logDevDelete',
  'prov.physDevAttachDetach',
  'prov.physDevBlockUnblock',
] as const;

/**
 * All device-management permissions that can be overridden in standalone mode.
 * Extracted from the mock SDK stubs.
 */
export const DEVICE_MANAGEMENT_PERMISSIONS = [
  'dm.appRead',
  'dm.appVersionRead',
  'dm.appVersionWrite',
  'dm.appWrite',
  'dm.catalogShare',
  'dm.artifactDelete',
  'dm.artifactRead',
  'dm.artifactWrite',
  'dm.configModuleDelete',
  'dm.configModuleRead',
  'dm.configModuleWrite',
  'dm.configProfileDelete',
  'dm.configProfileRead',
  'dm.configProfileWrite',
  'dm.deploymentAutomatorRead',
  'dm.deploymentAutomatorWrite',
  'dm.deploymentRequestRead',
  'dm.deploymentRequestUninstallWrite',
  'dm.deploymentRequestWrite',
  'dm.deploymentUnitRead',
  'dm.deviceDiagRead',
  'dm.deviceGeofencingRead',
  'dm.deviceGroupRead',
  'dm.deviceGroupWrite',
  'dm.deviceLogcatRead',
  'dm.deviceLogcatWrite',
  'dm.deviceScreenLockingWrite',
  'dm.deviceStateRead',
  'dm.deviceStateWrite',
  'dm.osRead',
  'dm.osVersionRead',
  'dm.osVersionWrite',
  'dm.osWrite',
  'dm.resourceDelete',
  'dm.resourceRead',
  'dm.resourceWrite',
  'dm.screenShareCreate',
  'dm.systemPackageRead',
  'dm.systemPackageVersionRead',
  'dm.systemPackageVersionWrite',
  'dm.systemPackageWrite',
  'dm.templateDelete',
  'dm.templateRead',
  'dm.templateWrite',
] as const;

export const OVERRIDABLE_PERMISSIONS = [
  ...new Set([...DEVICE_MANAGEMENT_PERMISSIONS, ...PROVISIONING_PERMISSIONS]),
] as const;

export type DeviceManagementPermission = (typeof OVERRIDABLE_PERMISSIONS)[number];

export type PermissionOverrideValue = boolean;

export type PermissionOverrides = Partial<Record<DeviceManagementPermission, PermissionOverrideValue>>;
